import { Button } from "@/components/design-system/Button/Button";
import { StatCard } from "@/components/design-system/StatCard/StatCard";
import { FEATURE_FLAGS } from "@/data/featureFlags";
import { trackCalendlyClick } from "@/utils/analytics";
import React from "react";
import { stats } from "./WealthStatsSection.data";

type WealthStatsSectionProps = {
  onOpenCalc: () => void;
};

export const WealthStatsSection: React.FC<WealthStatsSectionProps> = ({
  onOpenCalc,
}) => {
  const handleOpenCalc = () => {
    trackCalendlyClick("wm_stats");
    onOpenCalc();
  };

  return (
    <section id="wm-stats" className="bg-primary-700 w-full">
      <div className="mx-auto max-w-360 px-5 py-16 md:px-8 md:py-24 lg:px-16">
        <div className="mb-12 flex flex-col items-center gap-6 text-center md:mb-16 xl:mx-auto xl:max-w-282">
          <p className="caption-bold text-white uppercase">
            The Hidden Opportunity
          </p>
          <h2 className="headline-d-extrabold md:headline-c-extrabold text-white">
            Trillions in participant assets are being left on the table.
          </h2>
          <p className="body-a-regular md:subtitle-b-regular max-w-282 text-white">
            Most retirement plan advisers are leaving significant AUM on the
            table. Not because the assets don&apos;t exist — because there is no
            scaleable mechanism to surface them.
          </p>
        </div>

        <div className="mb-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 xl:mx-auto xl:max-w-282">
          {stats.map((stat) => (
            <StatCard
              key={stat.value}
              stat={stat.value}
              description={stat.description}
              className="shadow-[0px_0px_30px_var(--color-primary-900)]"
              statClassName="bg-accent-blue-bg text-accent-blue"
            />
          ))}
        </div>

        {FEATURE_FLAGS.showCalculators && (
          <div className="flex justify-center">
            <Button
              variant="outline"
              size="lg"
              onClick={handleOpenCalc}
              className="body-a-semibold inline-flex h-12 items-center justify-center rounded-[10px] border border-white bg-transparent px-6 text-white transition hover:bg-white/10 focus:ring-0 focus:ring-offset-0"
            >
              Calculate your AUM opportunity
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};
